<div  class="pages-result__img-col">
	<template v-if="imageUrl">
		<img :src="imageUrl + '?hei=90'" :alt="title" class="pages-result__img">
	</template>
	<template v-else>
		<div class="pages-result__icon">
			<span class="icon-newspaper"></span>
		</div>
	</template>
</div>
